<template lang="pug">
#layout
  //- Header(:title="title", :logo="logo")
  Navigation(:nav="nav")
  Frame(:pushToDataLayer="pushToDataLayer")
  //- Drawer(:title="title")
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

import Navigation from "../components/global/Navigation.vue";
import Frame from "../components/global/Frame.vue";

export default {
  name: "Layout",
  props:['pushToDataLayer'],
  components: {
    Navigation,
    Frame,
  },
  setup() {
    const store = useStore();
    return {
      nav: computed(() => store.getters.nav),
    };
  },
};
</script>

<style scoped lang="scss">
#layout {
  display: contents;
}
</style>
